import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table"
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@/components/ui/table"
import { FilterTableDataProps } from "@/types/types"
import { Checkbox } from "@/components/ui/checkbox"
import { SelectOption } from "@/types/inputField"

export const FilterDataTable = ({
  columns,
  data,
  selectedFilters,
  onChange
}: FilterTableDataProps<SelectOption>
) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <div className="rounded-md border w-full max-h-[380px] overflow-y-auto">
      <Table className="">
        <TableBody className="text-primary">
          {table.getRowModel().rows.map((row) => (
            <TableRow
              key={row.id}
              data-state={row.getIsSelected() && "selected"}
              className="bg-primary-foreground hover:bg-border/5 hover:cursor-pointer overflow-x-hidden"
              onClick={() => onChange(String(row.original.id))}
            >
              {row.getVisibleCells().map((cell) => {
                if (cell.column.id === 'checkbox') {
                  return (
                    <TableCell key={cell.id}>
                      <Checkbox
                        id='checkboxFilter'
                        checked={selectedFilters.includes(String(cell.getContext().row.original.id))}
                        onCheckedChange={() => onChange(String(cell.getContext().row.original.id))}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </TableCell>
                  )
                } else {
                  return (
                    <TableCell key={cell.id} className="flex flex-col items-start justify-start">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      <span className="text-secondary">
                        {row.original.description}
                      </span>
                    </TableCell>
                  )
                }
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
